export default __webpack_public_path__ + "static/media/collection-sent.b5003b29.svg";